/**
 * Firebase analytics events for MF, MF_NRI, and BROKING client KYC flows.
 */

import {KYC_FLOWS} from 'constants/FlowConstants';

export const KYC_FIREBASE_EVENTS = {
  BANK_ADDED: 'onb_bank_added',
  BANK_VERIFIED: 'onb_bank_verified',
  NOMINATION_COMPLETED: 'onb_nomination_completed',
  SIGNATURE_COMPLETED: 'onb_signature_completed',
  IPV_COMPLETED: 'onb_ipv_completed',
  TRADING_SEGMENTS_SELECTED: 'onb_trading_segments_selected',
  ESIGN_STARTED: 'onb_esign_started',
  ESIGN_COMPLETED: 'onb_esign_completed',
  DIGILOCKER_COMPLETED: 'onb_digilocker_completed',
  DIGILOCKER_INITIATED: 'onb_digilocker_initiated',
};

export const KYC_FIREBASE_TARGET_FLOWS = [KYC_FLOWS.MF, KYC_FLOWS.MF_NRI, KYC_FLOWS.BROKING];

export const BANK_VERIFICATION_TYPE = {
  UPI: 'upi',
  PD: 'pd',
  MANUAL: 'manual',
};

export const KYC_TYPE = {
  ALL_IN_ONE: 'all_in_one',
  BASIC: 'basic',
};

export const KYC_JOURNEY_TYPE = {
  ALL_IN_ONE: 'all_in_one',
  MF_TO_DEMAT_UPGRADE: 'mf_to_demat_upgrade',
};

const BROKING_FLOWS = [KYC_FLOWS.BROKING, KYC_FLOWS.BROKING_FNO];

export const shouldLogKycFirebaseEvent = (flow) => KYC_FIREBASE_TARGET_FLOWS.includes(flow);

export const getKycTypeEventValue = (flow) => {
  if (BROKING_FLOWS.includes(flow)) {
    return KYC_TYPE.ALL_IN_ONE;
  }

  return KYC_TYPE.BASIC;
};

export const getKycJourneyTypeEventValue = (flow, kycData = {}) => {
  const context = kycData?.context || {};

  if (
    context.mf_to_demat_upgrade === true ||
    context.mfToDematUpgrade === true ||
    kycData?.journeyType === KYC_JOURNEY_TYPE.MF_TO_DEMAT_UPGRADE
  ) {
    return KYC_JOURNEY_TYPE.MF_TO_DEMAT_UPGRADE;
  }

  if (BROKING_FLOWS.includes(flow)) {
    return KYC_JOURNEY_TYPE.ALL_IN_ONE;
  }

  return KYC_JOURNEY_TYPE.ALL_IN_ONE;
};
